import React from "react";
import Layout from "../../include/layout";
import AddVehicleInformationView from "./views/AddVehicleInformationView";
import useVehicleInfomation from "./hooks/addVehicleInformation.hook";
import Loader from "../../../components/loader";

const AddVehicleInformation = props => {
    const vehicleInformationHook = useVehicleInfomation();
    if(vehicleInformationHook?.loading) {
        return <Loader/>
    } else {


    return (
        <>
            <Layout>
                <AddVehicleInformationView {...vehicleInformationHook} />
            </Layout>
        </>
    )
    }
}

export default AddVehicleInformation;